// extracted by mini-css-extract-plugin
var _1 = "VideoUnavailable-module_message__JfEyg";
var _2 = "VideoUnavailable-module_wrapper__oHF5m";
export { _1 as "message", _2 as "wrapper" }
export default { "message": _1, "wrapper": _2 }
